export default "__VITE_ASSET__6940c749__"